/**
 * @generated SignedSource<<4bfb662bec37c8e73c35d6a0be2f7626>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteHubInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type Hub_Delete_Mutation$variables = {
  input: DeleteHubInput;
};
export type Hub_Delete_Mutation$data = {
  readonly deleteHub: {
    readonly deletedId: string | null | undefined;
  } | null | undefined;
};
export type Hub_Delete_Mutation$rawResponse = {
  readonly deleteHub: {
    readonly deletedId: string | null | undefined;
  } | null | undefined;
};
export type Hub_Delete_Mutation = {
  rawResponse: Hub_Delete_Mutation$rawResponse;
  response: Hub_Delete_Mutation$data;
  variables: Hub_Delete_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Hub_Delete_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteHubPayload",
        "kind": "LinkedField",
        "name": "deleteHub",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Hub_Delete_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteHubPayload",
        "kind": "LinkedField",
        "name": "deleteHub",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a6828f5a940daf815bd84f539293101",
    "id": null,
    "metadata": {},
    "name": "Hub_Delete_Mutation",
    "operationKind": "mutation",
    "text": "mutation Hub_Delete_Mutation(\n  $input: DeleteHubInput!\n) {\n  deleteHub(input: $input) {\n    deletedId\n  }\n}\n"
  }
};
})();

(node as any).hash = "9750734580f9f872047f706153a1f547";

export default node;
